function g(u, o, f, s) {
  function l(t) {
    return u.find((e) => e.ingredientId === t);
  }
  let c = 0, p = 0;
  if (f) {
    const t = o.filter((e) => !e.selected).sort((e, n) => e.position - n.position);
    s ? c = (t.length > s ? t.slice(0, s) : t).reduce(
      (i, d) => {
        const r = l(d.id);
        return r ? i - r.price : i;
      },
      0
    ) : c = t.reduce(
      (e, n) => {
        const i = l(n.id);
        return i ? e - i.price : e;
      },
      0
    );
  }
  return p = o.reduce(
    (t, e) => {
      const n = l(e.id);
      if (n && e.replacementId) {
        const { replacementId: i } = e, d = n.replacements.find(
          (r) => r.ingredientId === i
        );
        if (d)
          return t + d.price;
      }
      return t;
    },
    0
  ), p + c;
}
export {
  g as default
};
